import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";
import { useDnDBypassContext } from "@/components/builder/utils/bypass-context";

import BasePreview from "../../../base";

function FormCheckBoxMultiLabelPreview({ ...props }) {
  const { data: { value } } = useDnDBypassContext()

  return <BasePreview {...props}>
    <span>
      {value?.label}
    </span>
  </BasePreview>
}

export default define('form-checkbox-multi-label', FormCheckBoxMultiLabelPreview, Fragment)
  .shared(prop.share('FormCheckboxMultiLabel', 'form-checkbox-multi-label'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

